const locale: Locale = {
  ko: {
    changePwd: '비밀번호 변경',
    currentPwd: '현재 비밀번호를 입력하세요',
    newPwd: '새로운 비밀번호를 입력하세요',
    confirmPwd: '새로운 비밀번호를 재입력하세요',

    notCurrentPwd: '현재 비밀번호가 일치하지 않습니다.',
    diffPwd: '비밀번호가 일치하지 않습니다.',
    formatPwd: '영문과 숫자를 포함한 8자리 이상의 비밀번호를 설정해주세요',
    samePwd: '현재 비밀번호와 다른 새로운 비밀번호를 입력해주세요.',

    changeBtn: '비밀번호 재설정',

    success: '성공!',
    pwdChanged: '비밀번호가 재설정되었습니다.',
  },
  en: {
    changePwd: 'Change Password',
    currentPwd: 'current password',
    newPwd: 'new password',
    confirmPwd: 'confirm new password',

    notCurrentPwd: 'Your current password is missing or incorrect.',
    diffPwd: 'Passwords do not match.',
    formatPwd:
      'Password must be at least 8 characters and contain both numbers and letters.',
    samePwd: 'Your new password cannot be the same as your current password.',

    changeBtn: 'Change Password',

    success: 'Success!',
    pwdChanged: 'Password was changed.',
  },
}

export default locale
